export default {
    Search: 'جستجو',
    'No results found.': 'نتیجه‌ای یافت نشد.',
    cancel: 'انصراف'
};



//////////////////
// WEBPACK FOOTER
// ../~/mmenu-js/dist/addons/searchfield/translations/fa.js
// module id = 83
// module chunks = 0